import styled from "styled-components";

import { TabSelectMenu } from "../../../UI/TabSelectMenu/TabSelectMenu";
import Media from "../../../../utils/media";

export const TabSelectDropdownMenu = styled<any>(TabSelectMenu)`
  position: absolute;
  left: 0;
  top: 100%;
  box-style: border-box;
  margin: 0 16px;
  max-width: calc(100% - 32px);

  ${Media.tablet`
    margin: 4px 0 0 0;
    max-width: 326px;
  `};
`;
